import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { ActionIconContainer } from "./TableElements";
import { LinkSpan } from "./form/FormElements";
import { postApi } from "../../api/getUser";
import { useTranslation } from "react-i18next";

const PaymentOverdueBanner = () => {
  const { t } = useTranslation("common");
  const { isPaymentOverdue, setIsPaymentOverdue } = useAuth();

  const handleClose = () => {
    setIsPaymentOverdue(false);
  };

  const handlePayNow = async () => {
    const res = await postApi(
      {
        querystring: "get_due_invoice_details",
      },
      "subscription"
    );
    console.log("res", res);
    if (res.success) {
      const { invoices } = res;
      if (invoices.hosted_invoice_url) {
        window.open(invoices.hosted_invoice_url, "_blank");
      }
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between w-100"
      style={{
        padding: "5px 10px",
        background: "#FFEBEB",
        border: "1px solid #FFEBEB",
        //borderRadius: "5px",
        zIndex: 100,
        position: "fixed",
        height: "40px",
      }}
    >
      <div className="d-flex align-items-center gap-1">
        <i
          className="fi fi-rr-triangle-warning"
          style={{
            color: "red",
            //marginRight: "6px",
            position: "relative",
            top: "2px",
          }}
        />
        <p>
          <strong style={{ fontWeight: 500 }}>
            {`${t("payment_overdue")}:`}{" "}
          </strong>
          {t("payment_overdue_msg")}
        </p>
      </div>
      <div className="d-flex align-items-center gap-1">
        <LinkSpan
          style={{ color: "red", borderColor: "red" }}
          onClick={handlePayNow}
        >
          {t("pay_now")}
        </LinkSpan>
        <ActionIconContainer onClick={handleClose}>
          <i className="fi fi-rr-cross-small" />
        </ActionIconContainer>
      </div>
    </div>
  );
};

export default PaymentOverdueBanner;
